var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossLightinline = function SvgCrossLightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M.913.913a.557.557 0 0 1 .788 0L15.087 14.3a.557.557 0 1 1-.787.787L.912 1.7a.557.557 0 0 1 0-.788",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M.913 15.087a.557.557 0 0 1 0-.787L14.3.912a.557.557 0 1 1 .787.788L1.7 15.087a.557.557 0 0 1-.788 0",
    clipRule: "evenodd"
  })));
};
export default SvgCrossLightinline;